var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('DxPopover',{class:[{
             bgBlack: _vm.styleBackgound},
           {'enable-scroll': _vm.enableScroll},
           {'popover-arrow-none': _vm.hideArrow},
           {'none-padding-two-side' : _vm.nonePaddingTwoSide}
  ],attrs:{"max-height":_vm.maxHeight,"min-height":_vm.minHeight,"width":_vm.width,"visible":_vm.visible,"target":_vm.target,"position":_vm.position,"close-on-outside-click":_vm.closeOnOutsideClick},on:{"hiding":_vm.closePopover}},[_c('div',{staticClass:"content-container",on:{"keyup":_vm.handleKeyUp}},[_vm._t("content",null,{"id":"popover"})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }